import React, { useState } from "react";
import { X, Plus } from "lucide-react";
import AiPromptGenerator from "@/components/resume-builder/AiPromptGenerator";

/** Generic chip-list section, reused for Hobbies and Extra-Curricular Activities
 * (same interaction pattern as SkillsSection, parameterized by draft field/label). */
export default function TagListSection({ draft, setDraft, field, label, placeholder, testPrefix }) {
  const [input, setInput] = useState("");
  const items = draft[field] || [];

  const addItem = () => {
    const val = input.trim();
    if (val && !items.includes(val)) {
      setDraft({ ...draft, [field]: [...items, val] });
    }
    setInput("");
  };

  const removeItem = (item) => setDraft({ ...draft, [field]: items.filter((s) => s !== item) });

  return (
    <div className="glass-panel rounded-2xl p-5" data-testid={`resume-section-${testPrefix}`}>
      <p className="text-sm font-semibold text-white mb-3">{label}</p>
      <div className="flex gap-2 mb-3">
        <input
          value={input} onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), addItem())}
          placeholder={placeholder} data-testid={`resume-${testPrefix}-input`}
          className="flex-1 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:ring-1 focus:ring-indigo-400"
        />
        <button onClick={addItem} data-testid={`resume-add-${testPrefix}-button`} className="flex items-center gap-1 bg-white/10 hover:bg-white/15 text-white text-xs font-semibold px-3 py-2 rounded-lg transition-colors">
          <Plus className="w-3.5 h-3.5" /> Add
        </button>
      </div>
      <div className="flex flex-wrap gap-2 mb-3" data-testid={`resume-${testPrefix}-list`}>
        {items.map((item) => (
          <span key={item} className="flex items-center gap-1.5 text-xs font-medium bg-indigo-400/10 border border-indigo-400/30 text-indigo-300 rounded-full px-3 py-1" data-testid={`resume-${testPrefix}-chip-${item}`}>
            {item}
            <button onClick={() => removeItem(item)} data-testid={`resume-remove-${testPrefix}-${item}`}><X className="w-3 h-3" /></button>
          </span>
        ))}
      </div>
      <AiPromptGenerator section={field} draft={draft} setDraft={setDraft} />
    </div>
  );
}
